export function formatRequestProtocol(protocol?: number) {
  if (protocol) {
    const stringValue = String(protocol)
    return stringValue.padStart(8, '0')
  }

  return '--'
}
